import { render, staticRenderFns } from "./DetailItem.vue?vue&type=template&id=93dce8c6&scoped=true&"
import script from "./DetailItem.vue?vue&type=script&lang=js&"
export * from "./DetailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dce8c6",
  null
  
)

export default component.exports